/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S4_P2Inputs */

const tr_mesafeli_s4_p2 = /** @type {(inputs: Mesafeli_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sözleşme'nin bir nüshası Müşteri'nin kayıt e-posta adresine kalıcı veri saklayıcı sıfatıyla iletilir; aynı zamanda Müşteri hesabı içinde her zaman erişilebilir tutulur.`)
};

const en_mesafeli_s4_p2 = /** @type {(inputs: Mesafeli_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A copy of the Agreement is sent to the Customer's registration email address as a durable medium; it is also kept accessible at all times within the Customer account.`)
};

const de_mesafeli_s4_p2 = /** @type {(inputs: Mesafeli_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Exemplar des Vertrages wird als dauerhafter Datenträger an die bei der Registrierung angegebene E-Mail-Adresse des Kunden übermittelt; es wird zugleich im Kundenkonto jederzeit zugänglich gehalten.`)
};

const ru_mesafeli_s4_p2 = /** @type {(inputs: Mesafeli_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экземпляр Договора направляется на указанный при регистрации адрес электронной почты Клиента в качестве постоянного носителя данных; он также постоянно доступен в личном кабинете Клиента.`)
};

/**
* | output |
* | --- |
* | "A copy of the Agreement is sent to the Customer's registration email address as a durable medium; it is also kept accessible at all times within the Customer..." |
*
* @param {Mesafeli_S4_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s4_p2 = /** @type {((inputs?: Mesafeli_S4_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S4_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s4_p2(inputs)
	if (locale === "de") return de_mesafeli_s4_p2(inputs)
	if (locale === "ru") return ru_mesafeli_s4_p2(inputs)
	return tr_mesafeli_s4_p2(inputs)
});